module.exports = import("//cdn.skypack.dev/three@0.134/examples/jsm/controls/OrbitControls?min");;